import LegalPage from "@/pages/legal/LegalPage";

export default function Refunds() {
  return (
    <LegalPage title="Refund &amp; Cancellation Policy" updated="February 5, 2026">
      <p>
        This policy describes how refunds and cancellations work for Immersive+ subscriptions
        on <a href="https://imrsvprtl.com">imrsvprtl.com</a>.
      </p>

      <h2>Immersive+ Subscription</h2>
      <p>
        Immersive+ is a recurring monthly digital subscription priced at{" "}
        <strong>$14.99 USD per month</strong>. When you subscribe, access to Immersive+
        features is granted immediately.
      </p>

      <h2>Refund Policy</h2>
      <p>
        <strong>All Immersive+ subscription fees are non-refundable.</strong> Because
        Immersive+ unlocks digital content and AI processing that is consumed the moment
        it is delivered, we do not offer refunds for:
      </p>
      <ul>
        <li>Subscription periods that have already begun</li>
        <li>Unused portions of a billing cycle after cancellation</li>
        <li>Accidental purchases (please cancel <em>before</em> your next billing date to avoid the charge)</li>
        <li>Changes of mind after the subscription is active</li>
      </ul>

      <h3>Exceptions</h3>
      <p>
        We will provide a refund in the following limited circumstances:
      </p>
      <ul>
        <li><strong>Duplicate charges</strong> caused by a payment system error</li>
        <li><strong>Fraudulent charges</strong> where you did not authorize the transaction</li>
        <li><strong>Extended service outage</strong> — if Immersive+ features are unavailable for more than 72 continuous hours due to our fault, we will credit or refund a pro-rated portion of your subscription</li>
        <li><strong>Statutory rights</strong> — where applicable law (such as EU/UK consumer protection statutes) grants you a right to withdraw within 14 days AND you have not used the paid features during that period. If you have used Immersive+ features you waive the statutory withdrawal right</li>
      </ul>
      <p>
        Refund requests must be submitted within 30 days of the charge to{" "}
        <a href="mailto:billing@imrsvprtl.com">billing@imrsvprtl.com</a> with your account
        email, the last 4 digits of the payment method, and the transaction date. Approved
        refunds are issued to the original payment method within 5-10 business days.
      </p>

      <h2>Cancellation</h2>
      <p>
        You can cancel your Immersive+ subscription at any time. To cancel:
      </p>
      <ol className="list-decimal pl-5 my-3 space-y-1">
        <li>Open the app and go to <strong>Settings → Subscription</strong></li>
        <li>Click <strong>Cancel Immersive+</strong> and confirm</li>
      </ol>
      <p>
        After cancellation, you keep Immersive+ features until the end of your current
        paid billing period. No further charges will occur.
      </p>

      <h2>Chargebacks</h2>
      <p>
        If you dispute a charge with your bank without first contacting us, we may suspend
        your account pending resolution. We strongly encourage you to contact{" "}
        <a href="mailto:billing@imrsvprtl.com">billing@imrsvprtl.com</a> before initiating
        a chargeback so we can resolve the issue directly.
      </p>

      <h2>Free Tier</h2>
      <p>
        The free tier of Immersive Character AI is provided at no cost and no refunds apply.
        Free-tier feature availability may change without notice.
      </p>

      <h2>Contact</h2>
      <p>
        Billing questions: <a href="mailto:billing@imrsvprtl.com">billing@imrsvprtl.com</a><br />
        General support: <a href="mailto:support@imrsvprtl.com">support@imrsvprtl.com</a>
      </p>
    </LegalPage>
  );
}
